import styles from './loginlinks.module.css';
import { Link, useLocation } from "react-router-dom";

export function LoginLinks() {
    const location = useLocation();

    return (
        <div className={styles.links}>
            <Link
                className={styles.link}
                to="/reset-password"
            >
                Восстановить пароль
            </Link>
            <Link
                className={styles.link}
                to="/login/privacy-policy"
                state={{ background: location }}
            >
                Политика конфиденциальности
            </Link>
        </div>
    )
}